import { Injectable } from '@angular/core';

/** String utilities */
@Injectable({
  providedIn: 'root',
})
export class StringService {
  snakeCase = (s: string): string => s.toLowerCase().replace(' ', '_');
}
